import ImageService from '@/services/ImageService'  
import GLTFService from '@/services/GLTFService' 
 
import AppStore from 'src/store/app'
import { HOME, PATHS } from '@/config/app'
import Env from 'src/config/env'
import AnimationConfig from 'src/config/animation'

import { clamp, map, DEG_TO_RAD } from '@/helpers/MathUtils'
import Pointer from '@/helpers/Pointer'
import EventEmitter from 'src/helpers/EventEmitter'
  
import BaseGroup from '@/components/stage/common/base_group'
 
import CustomEase from 'gsap/CustomEase'
import gsap from 'gsap'
import dat from 'dat.gui' 

const THREE = require('three')
import { SkeletonUtils } from 'three/examples/jsm/utils/SkeletonUtils.js'

// displacement
import vert_morph from '@/shaders/displacement/vertex_morph.glsl'
import vert_before_morph from '@/shaders/displacement/vertex_before_morph.glsl'

gsap.registerPlugin(CustomEase)

const Events = {}
 

class BubbleGroup extends BaseGroup {

  constructor(config) { 

    super(config) 


    this.Events = Events
    Object.assign(this, EventEmitter)

    this.render = false

    this.content = null
    this.mixer = null
    this.morphFolder = null
    this.morphCtrls = [] 
    this.morphMeshes = []
    this.clips = []

    this.welcomeOpacity = 0.7
    this.tweenObj = { 
      opacity: this.welcomeOpacity 
    }

    const displacement = AppStore.state.home.sections[0].bubble.displacement
    this.options = {
      displacement: {
        density: displacement.density,
        amt: displacement.amt,
        speed: displacement.speed
      } 
    }
    this.materialThreshold = config.material || null
    
    this.setup()
    this.resize() 
  }

  setup() {
    this.customEase = CustomEase.create("custom", "M0,0 C0,0 0.03181,-0.02153 0.04135,-0.03862 0.06684,-0.08431 0.07307,-0.13105 0.09946,-0.17827 0.11351,-0.20342 0.13214,-0.22156 0.15302,-0.23846 0.16265,-0.24625 0.17564,-0.24897 0.1883,-0.25015 0.2009,-0.25132 0.21267,-0.24951 0.22494,-0.24516 0.23971,-0.23993 0.25113,-0.2334 0.26376,-0.22341 0.27809,-0.21207 0.29067,-0.20249 0.29861,-0.18689 0.31654,-0.15167 0.32654,-0.12154 0.337,-0.07955 0.35408,-0.011 0.36238,0.03143 0.37093,0.10345 0.40589,0.39805 0.41544,0.56114 0.4486,0.8608 0.45994,0.96334 0.46704,1.01966 0.48329,1.11898 0.48917,1.15495 0.49366,1.17855 0.50581,1.21061 0.51465,1.23395 0.52593,1.25125 0.54049,1.26991 0.54702,1.27828 0.55634,1.28459 0.56579,1.28748 0.57522,1.29036 0.58731,1.29028 0.59652,1.28702 0.60586,1.28372 0.61394,1.27627 0.62114,1.26792 0.62989,1.25776 0.63591,1.24853 0.64086,1.23556 0.65184,1.20679 0.65877,1.18643 0.6643,1.15481 0.68215,1.05273 0.68109,0.97387 0.702,0.886 0.70668,0.86631 0.72421,0.84762 0.73965,0.83824 0.75199,0.83073 0.7749,0.82887 0.78807,0.83366 0.80146,0.83854 0.81326,0.85421 0.82307,0.8686 0.83291,0.88305 0.83866,0.89627 0.84289,0.91409 0.85444,0.96276 0.85339,1.00371 0.86559,1.04769 0.86883,1.05938 0.87868,1.06908 0.88781,1.07605 0.89393,1.08072 0.90342,1.08249 0.91109,1.08244 0.91685,1.0824 0.92432,1.08025 0.92792,1.07576 0.94201,1.05819 0.94914,1.03189 0.96488,1.01535 0.9734,1.0064 1,1 1,1 ")
  }

  setupMesh(){

    const gltf = GLTFService.get( require('@/assets/models/bubble.glb') )
    const scene = gltf.scene || gltf.scenes[0]
    const clips = gltf.animations || []
    
    this.content = scene
    this.clips = clips
    this.mixer = new THREE.AnimationMixer( scene )


    this.content.traverse((node) => {
      if (node.isMesh && node.morphTargetInfluences) {
        this.morphMeshes.push(node);
      } 
    }) 
  
    if(!this.materialThreshold){ 
      this.materialThreshold = new THREE.MeshMatcapMaterial({
        matcap: this.textures.blue_matcap,
        opacity: this.welcomeOpacity, 
        transparent: true,
        depthWrite: false 
      })  
    }

    this.materialThreshold.morphTargets = true
    this.materialThreshold.depthTest = true
    this.materialThreshold.depthWrite = true  
    //depthFunc: THREE.LessEqualDepth,
    
    this.materialThreshold.userData.time = { value: 2 } 
    this.materialThreshold.userData.density = { value: this.options.displacement.density } 
    this.materialThreshold.userData.amt = { value: this.options.displacement.amt } 
    this.materialThreshold.userData.speed = { value:  this.options.displacement.speed } 

    this.materialThreshold.onBeforeCompile = ( shader ) => { 
      shader.uniforms.time = this.materialThreshold.userData.time; 
      shader.uniforms.density = this.materialThreshold.userData.density
      shader.uniforms.amt = this.materialThreshold.userData.amt
      shader.uniforms.speed = this.materialThreshold.userData.speed 
      shader.vertexShader = vert_before_morph + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace( '#include <begin_vertex>', vert_morph ); 
    }

  
    let m = scene.children[0]
    this.geometry = m.geometry
 
    this.meshThreshold = new THREE.Mesh( this.geometry, this.materialThreshold )
    this.meshThreshold.name = 'meshThreshold'
    this.meshThreshold.morphTargetDictionary = m.morphTargetDictionary
    this.meshThreshold.morphTargetInfluences = m.morphTargetInfluences
    this.meshThreshold.position.y = -0.7 
    this.meshThreshold.scale.y = this.meshThreshold.scale.z = 1.3
    this.meshThreshold.scale.x = 0.3
    

    this.position.x = -0.4
    this.position.y = -0.4 


    this.add(this.meshThreshold)
  }
 
 
  // addGUI() {
  //   if(this.gui){
  //     // Morph target controls.
  //     let bubbleFolder = this.gui.addFolder('Bubble')
  //     let displacementFolder = bubbleFolder.addFolder('Displacement')
  //     displacementFolder.add(this.options.displacement, 'amt', 0, 1).onChange(this.onBubbleChange)
  //     displacementFolder.add(this.options.displacement, 'speed', 0, 1).onChange(this.onBubbleChange)
  //     displacementFolder.add(this.options.displacement, 'density', 0, 1).onChange(this.onBubbleChange)
   
  //     this.morphFolder = bubbleFolder.addFolder('Morph Targets') 
  //   }
  // }

  updateGUI () {

    if(this.gui){
      this.morphCtrls.forEach((ctrl) => ctrl.remove())
      this.morphCtrls.length = 0

      const cameraNames = []
      const morphMeshes = []
      this.content.traverse((node) => {
        if (node.isMesh && node.morphTargetInfluences) {
          morphMeshes.push(node)
        } 
      })

      if (morphMeshes.length) { 
        morphMeshes.forEach((mesh) => {  
          let ctrl = null
          for (let i = 0; i < mesh.morphTargetInfluences.length; i++) {
            ctrl = this.morphFolder.add(mesh.morphTargetInfluences, i, 0, 1, 0.01).listen()
            Object.keys(mesh.morphTargetDictionary).forEach(key => {

              if (key && mesh.morphTargetDictionary[key] === i) ctrl.name(key)
            })
          } 
          this.morphCtrls.push(ctrl)
        })
      }
    }
  }
  

  pointerMove(event){ }

  pointerStart(event){
    //gsap.to(this.options.displacement, 1, { density: 0.3, amt: 0.1, ease: 'Power3.easeOut' })
  }

  pointerEnd(event){
    //gsap.to(this.options.displacement, 1, { density: 0.5, amt: 0.075, speed: 0.2, ease: 'Power3.easeOut' }) 
  }

  pulse(opacity){ 
    this.materialThreshold.opacity = opacity
  }



  // UPDATES -------------------------------------------------------------------
  
 
  tick( dt, time, pulseOpacity ) {  

    if(!this.render){
      return
    }

    if( this.materialThreshold && !this.reduced_motion ){  
      //let time = performance.now() / 1000
      this.materialThreshold.userData.time.value += dt
      this.materialThreshold.userData.amt.value = this.options.displacement.amt
      this.materialThreshold.userData.density.value = this.options.displacement.density
    }

    this.pulse(pulseOpacity)
  }

  resize() {
    let ww = window.innerWidth
    let wh = window.innerHeight
  } 

  destroy(){}

  pop(dir){

    const home = AppStore.state.home 
    const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT )
    if(isHomeModeDefault && dir !== -1){
        
      gsap.to(this.scale, this.getDuration(1), {
        x: 1.05, 
        y: 1.05,
        z: 1.05,
        delay: this.getDuration(AnimationConfig.home.section.duration * 0.6),
        ease: 'power4.in' 
      })
      gsap.to(this.scale, this.getDuration(1), {
        x: 1, 
        y: 1,
        z: 1,
        delay: this.getDuration(( AnimationConfig.home.section.duration * 0.6 ) + 1),
        ease: 'elastic.out' 
      })
    } 
  }

  bubbleLoaded(){
    this.setupMesh()
    //this.addGUI()
    //this.updateGUI()
    this.render = true 
  }  

  onSectionChange(val, prev){
    this.updateMorphTargets(val, prev)
    this.updateDisplacement(val, prev)  
  }

  updateMorphTargets(val, prev){
 
    if(
      this.morphMeshes && 
      val.morphIndex !== undefined && 
      prev && (val.morphIndex !== prev.morphIndex)
    ){
      
      const home = AppStore.state.home 
      const isHomeModeDefault = ( home.mode === HOME.MODES.DEFAULT ) 
      let clamp = this.reduced_motion ? 0 : 1
      let base_duration = isHomeModeDefault ? ( AnimationConfig.home.section.duration * 0.5 ) : 1.2
      let duration = base_duration * clamp
      let base_delay = ( AnimationConfig.home.section.duration * 0.6 )
      let delay = isHomeModeDefault ? (base_delay * clamp) : 0
      let tweenObj = { current: 0, prev: 0 } 

      let ease;
      if( isHomeModeDefault ){
        let navigationDelta = Math.abs(val.index -  prev.index ) 
        let deltaThreshold = 2 
        ease = ( navigationDelta > deltaThreshold ) ? 'power2.out' : 'back.inOut(8)'
      } else { 
        ease = 'elastic.out(0.5)'
      } 

      this.morphMeshes.forEach( mesh  => { 

        // current 
        gsap.to(tweenObj, duration, {
          current : 1, 
          onUpdate: () => { mesh.morphTargetInfluences[ val.morphIndex ] = tweenObj.current }, 
          delay: delay,
          ease: ease
        })
          
        // prev 
        if(prev){
          tweenObj.prev = mesh.morphTargetInfluences[ prev.morphIndex ]
          gsap.to(tweenObj, duration, {
            prev : 0, 
            delay: delay,
            onUpdate: () => { mesh.morphTargetInfluences[ prev.morphIndex ] = tweenObj.prev },
            ease: ease
          })
        }
      })
    } 
  }

  updateDisplacement(val, prev){
    let preset = val.bubble.displacement
    let clamp = this.reduced_motion ? 0 : 1
    let duration = 2 * clamp
    gsap.to(this.options.displacement, duration, {
      amt: preset.amt,
      density: preset.density
      //speed: preset.speed
    }) 
  }

  zoomOut(){
    let clamp = this.reduced_motion ? 0 : 1
    let duration = AnimationConfig.home.section.duration * clamp
    gsap.to(this.meshThreshold.scale, duration, {
      x: 0.8,
      y: 0.8,
      z: 0.8,
      ease: 'expo.out'
    })
    gsap.to(this.tweenObj, duration, {
      opacity: 0.5,
      ease: 'expo.inOut'
    }) 
    gsap.to(this.position, duration, {
      x: 0,
      y: 0, 
      ease: 'expo.inOut'
    })
  }

  zoomIn(section){
    let clamp = this.reduced_motion ? 0 : 1
    let duration = AnimationConfig.home.section.duration * clamp
    gsap.to(this.meshThreshold.scale, duration, {
      x: (section.index === 0 ? 1. : 2.8),
      y: 1.2 ,
      z: (section.index === 0 ? 1.3 : 2),
      ease: 'Expo.easeInOut'
    })
    gsap.to(this.tweenObj, duration, {
      opacity: (section.index === 0 ? this.welcomeOpacity : 0.2),
      ease: 'Expo.easeInOut'
    }) 
    gsap.to(this.position, duration, {
      x: -0.4,
      y: (section.index === 0 ? -0.4 : 0), 
      ease: 'Expo.easeInOut'
    })
  }

  getDuration(duration){ 
    let clamp = this.reduced_motion ? 0 : 1
    return ( duration * clamp )
  }



  // HANDLERS -------------------------------------------------------------------

  onMorphClick(index){}

  onBubbleChange = () => {  
    this.materialThreshold.userData.amt.value = this.options.displacement.amt
    this.materialThreshold.userData.speed.value = this.options.displacement.speed
    this.materialThreshold.userData.density.value = this.options.displacement.density 
  }


  // STATES -------------------------------------------------------------------

  /* modal states */

  /*  
    none
    menu
    video
  */

  /* page states */

  routeLoading(){ } 
 
  routeHome(){ 
    this.setup()
  }
  

  /* home states */
 
  welcome(val, prev){
    this.zoomIn(val)  
    this.onSectionChange(val, prev)
  }  
 
  ratingFive(val, prev, dir){  
    this.onSectionChange(val, prev) 
    this.zoomOut()
    
    gsap.to(this.position, this.getDuration(AnimationConfig.home.section.duration), {
      x: -0.1, 
      y: -0.1,
      ease: 'Expo.easeInOut'
    })

    this.pop(dir)
  } 

  ratingFour(val, prev){
    this.onSectionChange(val, prev)
    gsap.to(this.position, 1, { x: 0  })
    this.zoomOut()
  } 
 
  ratingThree(val, prev){
    this.onSectionChange(val, prev)
    gsap.to(this.position, 1, { x: 0  }) 
    this.zoomOut()
  }

  ratingTwo(val, prev){
    this.onSectionChange(val, prev)
    gsap.to(this.position, 1, { x: 0  }) 
    this.zoomOut()
  } 
 
  ratingOne(val, prev){
    this.onSectionChange(val, prev)
    this.zoomOut()
  } 

  cta(val, prev){ 
    this.zoomIn(val)
    this.onSectionChange(val, prev) 
  } 

}
 

export default BubbleGroup